import type { AppNavItemKey } from "../components/layout/commandCentreTypes";

/**
 * Sidebar navigation tour steps (v1). Targets use data-tour-nav on shell links.
 * Runtime list is filtered by useAppNavTourSteps (mirrors useAppNavItems / tier access).
 */

export interface AppNavTourStep {
  id: string;
  /** Matches AppNavItem.tourTargetId / data-tour-nav */
  targetId?: AppNavItemKey;
  title: string;
  body: string;
}

export const APP_NAV_TOUR_STEPS: AppNavTourStep[] = [
  {
    id: "welcome",
    title: "Welcome to the app menu",
    body: "This short tour highlights the left navigation. You can skip anytime or replay it from FAQ later.",
  },
  {
    id: "dashboard",
    targetId: "dashboard",
    title: "Dashboard",
    body: "Your home base: shortcuts, status, and entry points to your chart and programs.",
  },
  {
    id: "my-chart",
    targetId: "my-chart",
    title: "My Chart",
    body: "Open your personal Purple Star chart and core readings tied to your profile.",
  },
  {
    id: "calculate",
    targetId: "calculate",
    title: "Calculate",
    body: "Add or open charts for other people (clients, family, or prospects). The badge shows how many profiles you have saved.",
  },
  {
    id: "ai-wealth-assistant",
    targetId: "ai-wealth-assistant",
    title: "AI Wealth Assistant",
    body: "Chat-style guidance on wealth themes when this item appears in your menu (program access required).",
  },
  {
    id: "founder-report",
    targetId: "founder-report",
    title: "Founder Report",
    body: "Deep founder-focused report when your program includes it. Open it from here instead of hunting bookmarks.",
  },
  {
    id: "alignment-advantage",
    targetId: "alignment-advantage",
    title: "Alignment Advantage",
    body: "Your strategic playbook in the app. Use Download on that page for the PDF when you need an offline copy.",
  },
  {
    id: "monthly-consultation",
    targetId: "monthly-consultation",
    title: "Monthly Consultation",
    body: "Month-by-month consultation view when enabled for your account.",
  },
  {
    id: "faq",
    targetId: "faq",
    title: "FAQ",
    body: "Feature how-tos and next steps, including this tour.",
  },
  {
    id: "settings",
    targetId: "settings",
    title: "Settings",
    body: "Update your password, appearance, and sign out. Use Settings rather than the public forgot-password flow when you are already signed in.",
  },
  {
    id: "done",
    title: "You are set",
    body: "Explore any section from the menu. If something you expected is missing, check FAQ or email support.",
  },
];
